import React, { Component } from 'react';

import CamdetectParkinglocationsSelect from './CamdetectParkinglocationsSelect';

import { Form, Input, Button, Modal, InputNumber, Select, Switch, Icon } from 'antd';
const FormItem = Form.Item;
const { Option } = Select;

class CamdetectCamerasForm extends Component {

  state = {
    modalVisible: false,
    confirmDirty: false,
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Hesla si musí odpovídat!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], { force: true });
    }
    callback();
  };

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 11 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 22,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita">
          {getFieldDecorator('parkingLocationID', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <CamdetectParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationID: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Název kamery">
          {getFieldDecorator('cameraName', {
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Heslo">
          {getFieldDecorator('password', {
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            },
            {min: 8, message: 'Heslo musí mít minimálně 8 znaků.' },
            {
              required: true, message: 'Vyplňte prosím tuto položku!',
            },
            {
              validator: this.validateToNextPassword,
            }],
          })(
            <Input.Password />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Heslo pro kontrolu">
          {getFieldDecorator('confirmPassword', {
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            },
            {
              required: true, message: 'Vyplňte prosím tuto položku!',
            },
            {
              validator: this.compareToFirstPassword,
            }],
          })(
            <Input.Password onBlur={this.handleConfirmBlur} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title="Vytvoření nové kamery"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedCamerasForm = Form.create()(CamdetectCamerasForm);

export default WrappedCamerasForm;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasForm.js